module.exports = "/_next/static/images/84f0bbddf6298551f053d75cf0e6233d-digital-account-phone-main-screen@xs-1x.png.webp";